import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom Blood Group icon: Two blood drops with + and - signs.
 * Matches the exact design from the reference image.
 */
const BloodGroupSvgIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <defs>
      <mask id="blood-group-mask">
        {/* Everything under white is visible */}
        <rect x="0" y="0" width="64" height="64" fill="white" />
        {/* Everything under black is hidden. We draw the left drop to mask out the right drop. */}
        <path d="M 22 16 Q 36 36 36 46 A 14 14 0 0 1 8 46 Q 8 36 22 16 Z" fill="black" stroke="black" strokeWidth="2.5" strokeLinejoin="round" />
      </mask>
    </defs>

    <g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Right Drop (Back) - masked by Left Drop */}
      <g mask="url(#blood-group-mask)">
        <path d="M 42 6 Q 56 26 56 36 A 14 14 0 0 1 28 36 Q 28 26 42 6 Z" />
        {/* Minus Sign */}
        <line x1="37" y1="36" x2="47" y2="36" />
      </g>

      {/* Left Drop (Front) */}
      <path d="M 22 16 Q 36 36 36 46 A 14 14 0 0 1 8 46 Q 8 36 22 16 Z" />
      
      {/* Plus Sign */}
      <line x1="22" y1="41" x2="22" y2="51" />
      <line x1="17" y1="46" x2="27" y2="46" />
    </g>
  </SvgIcon>
);

export default BloodGroupSvgIcon;
